// extracted by mini-css-extract-plugin
export var promotionLink = "_uk-0";